<!-- Start your project here-->
<app-header></app-header>
<router-outlet></router-outlet>
<app-footer></app-footer>
<!-- /Start your project here-->